import { IconButton, Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { EducationContainer } from "app/components/educationbar/educationContainer";
import useEducationBar from "app/components/educationbar/educationHook";
import PageTitle from "app/components/React/PageTitle/PageTitle";
import { SubNav } from "app/components/sub-navigation-bar/SubNav";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { DEMAND_ANALYSIS_HOME_STATE_NAME } from "../../shared/constants";
import { DemandAnalysisFilters } from "../demand-analysis-filters";

import { KeywordListsComparisonNavCallToAction } from "./KeywordListsComparisonNavCallToAction";
import { KeywordListsComparisonNavQueryBar } from "./KeywordListsComparisonNavQueryBar";

export const KeywordListsComparisonNav = ({ preventShowEducationBar }: { preventShowEducationBar: boolean }) => {
    const t = useTranslation();
    const [showEducationIcon, showEducationBar, setValues] = useEducationBar(preventShowEducationBar);

    const onCloseEducationBar = () => {
        setValues(true, false);
    };

    const onEducationIconClick = () => {
        setValues(false, true);
    };

    const handleBackClick = () => {
        void proNavigator.go(DEMAND_ANALYSIS_HOME_STATE_NAME);
    };

    return (
        <SubNav
            topLeftComponent={<KeywordListsComparisonNavQueryBar />}
            bottomLeftComponent={
                <Flex
                    alignItems="center"
                    gap="8px"
                >
                    <Tooltip content={t("demand_analysis.navbar.back_button.tooltip.text")}>
                        <IconButton
                            type="flat"
                            iconName="arrow-left"
                            iconSize="xs"
                            onClick={handleBackClick}
                        />
                    </Tooltip>
                    <PageTitle
                        showEducationIcon={showEducationIcon}
                        onEducationIconClick={onEducationIconClick}
                    />
                </Flex>
            }
            topRightComponent={<KeywordListsComparisonNavCallToAction />}
            bottomRightComponent={<DemandAnalysisFilters />}
            education={showEducationBar ? <EducationContainer onCloseEducationComponent={onCloseEducationBar} /> : null}
        />
    );
};
